<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CardPopupImg
        :isModalVisible="modal.LKI01"
        :cardContentFlower="Flwimage"
        :cardContent="content"
        :CheckWidth="CheckWidth"
        :cardType="type"
        :openModal="openModal"
        :score="scoreTest"
      />
      <CardPopupInfoTranparent
        :isAddQueueShow="modal.LKA01"
        :cardContent="FlwData"
        :cardContentPaht="content"
        :CheckWidth="CheckWidth"
        :cardType="type"
        @updateUser="funcRoute"
      />
    </template>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import CardPopupImg from './components/CardPopupImg.vue';
import CardPopupInfoTranparent from './components/CardpopupInfoTranparent.vue';
import '../../../assets/scss/_chineseStyle.scss';
import '../../../assets/scss/_chineseIcon.scss';
import '../../../assets/scss/_chineseModalCustom.scss';
import LoadingMDL from '../../../components/loading/LoadingMDL';

export default {
  components: {CardPopupImg, CardPopupInfoTranparent, LoadingMDL},
  name: 'LKA01',
  data() {
    return {
      CheckWidth: window.innerWidth.toString(),
      code: '',
      lang: '',
      content: {},
      Flwimage: '',
      FlwData: {},
      modal: {
        LKI01: true,
        LKA01: false,
      },
      score: 0,
      type: 'flower',
      baseUrl: process.env.VUE_APP_URL_SOUND,
      MaxScore: [],
      MinimumScore: [],
      LessonID: 0,
      mode: {},
      assignmentTestScore: {},
      scoreTest: this.$store.getters[`necessary/getLKAScore`],
      courseSection: '',
      startTime: '',
      courseCode: '',
      condition: [],
      loading: true,
      v3Data: {},
    };
  },

  computed: {
    ...mapGetters({
      allCourse: 'template/getTemplateContent',
      assignmentTest: 'template/getAssignmentTest',
      getUserTemplate: 'template/getUserTemplate',
      getTemplatev3: 'v3/getTemplates',
    }),
  },

  watch: {
    getTemplatev3: function (val) {
      if (!val) return;

      this.v3Data = val;
      const template = val.templates[0];
      this.content = template;
      this.navigate = template.navigate;

      if (!template.enable) {
        const pathFormat = template.navigate.close.action.split('-');
        alert('Access denied!');
        this.$router.push(`/v3/${pathFormat[0]}/${pathFormat[1]}`);
      }

      this.checkScore(template);
      this.courseSection =
        this.$store.getters['necessary/getUserCourseSection'];

      this.loading = false;
    },

    assignmentTest: function (val) {
      this.assignmentTestScore = val;
      if (this.mode.assingmentmode == true) {
        this.score = this.assignmentTestScore.userscore;
      } else if (this.mode.posttestMode == true) {
        alert('posttestMode');
      } else if (this.mode.pretestMode == true) {
        alert('pretestMode');
      } else if (this.mode.testmode == true) {
        this.score = this.assignmentTestScore.userscore;
      } else {
        this.score = this.$store.getters['score/getPoint'];
      }
    },
  },

  mounted() {
    this.onLoad();
  },
  created() {},
  beforeDestroy() {},
  methods: {
    onLoad() {
      this.startTime = this.$helpers.getDateFormat();
      this.courseCode = this.$store.state.necessary.learningCourse;
      this.lang = this.$store.state.language.language;
      const contentId = `LKA01-${this.$route.params.id}`;
      this.$store.dispatch('v3/fetchTemplateByCode', contentId);
    },
    checkWidth() {
      if (this.CheckWidth > 800) {
        return 'container-chinese-card';
      } else if (this.CheckWidth <= 800) {
        return 'container-chinese-card-mobile';
      }
    },
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    openModal() {
      this.modal = {
        LKI01: false,
        LKA01: true,
      };
    },
    checkScore(data) {
      var Question = data.content.question;
      for (let i = 0; i < Question.length; i++) {
        this.MaxScore.push(Question[i].item[0].data);
        this.MinimumScore.push(Question[i].item[0].data++ + 1);
      }
      if (
        this.scoreTest >= this.MinimumScore[1] &&
        this.scoreTest <= this.MaxScore[2]
      ) {
        this.Flwimage = data.content.question[2].item[2].data;
        this.FlwData = data.content.question[2];
      } else if (
        this.scoreTest >= this.MinimumScore[0] &&
        this.scoreTest <= this.MaxScore[1]
      ) {
        this.Flwimage = data.content.question[1].item[2].data;
        this.FlwData = data.content.question[1];
      } else if (this.scoreTest >= 0 && this.scoreTest <= this.MaxScore[0]) {
        this.Flwimage = data.content.question[0].item[2].data;
        this.FlwData = data.content.question[0];
      } else if (this.scoreTest) {
        this.Flwimage = data.content.question[0].item[2].data;
        this.FlwData = data.content.question[0];
      } else {
        alert('Score Error!');
      }
    },
    funcRoute(path) {
      // this.$store.dispatch('template/saveUserTemplateData', {
      //   code: this.courseCode,
      //   template: this.content._id,
      //   section: this.courseSection,
      //   startTime: this.startTime,
      //   endTime: this.$helpers.getDateFormat(),
      //   condition: this.condition,
      // });
      const data = [
        {
          codeItem: this.v3Data.codeItem,
          courseId: this.$store.state.necessary.learningCourse,
          template: this.v3Data.templateID,
          section: this.$store.state.v3.v3EnrollData.data.section,
          content: this.v3Data.content,
          type: this.v3Data.type,
          answering: [],
          progress: 100,
          score: 0,
          maxScore: 0,
        },
      ];
      this.$store.dispatch('v3/saveContent', data);
      const str = path.split('-');

      const nextPath = `/v3/${str[0]}/${str[1]}`;
      this.$router.push(nextPath);
    },
  },
};
</script>
<style></style>
